import { db,auth } from "@/firebase"
const users_ref = db.collection("users")

async function getCurrentUser() {
    if (auth.currentUser !== null) {
      let doc = await db
        .collection("users")
        .doc(auth.currentUser.uid)
        .get();
      return  doc.data() ;
    } else {
      throw Error('firebase.auth().currentUser is null');
    }
  }

async function getUsers() {
    let users_list = []
    try {
        const unitsRef = await users_ref.get()
        unitsRef.forEach((doc) => users_list.push(doc.data()));
        return users_list
    } catch (error) {
        console.error(error)
    }
}
async function getUsersById(idUser) {
    try {
        const user = await users_ref.doc(idUser).get()
        return user.data()
    } catch (error) {
        console.error(error)
    }
}

const arrayChunkSeparate500 = async (data, chunkSize = 500) => {
    let result = []
    for (let i = 0; i < data.length; i += chunkSize) {
        const chunk = data.slice(i, i + chunkSize);
        result.push(chunk)
    }
    return result
}

async function getUsersByIdList (idList) {
    let users = [];
    try {
        if (idList.length){
            const arraySeparated = await arrayChunkSeparate500(idList,10)
            for (let listConsult of arraySeparated) {
                const doc = await users_ref.where("id","in",listConsult).get();
                doc.forEach((user) => {
                    users.push(user.data());
                });
            }
        }
        return users;
    } catch (error) {
        console.error(error);
        throw error;
    }
}

async function getUsersByRank(rank) {
    try {
        let users_list = []
        let get_users = await users_ref.where("rank", "==", rank).get()

        get_users.forEach((doc) => {
            users_list.push(doc.data());
        });
        return users_list
    } catch (error) {
        console.error(error)
    }
}
async function getUsersByIdRole(idRole) {
    try {
        let users_list = []
        let get_users = await users_ref.where("id_role", "==", idRole).get()

        get_users.forEach((doc) => {
            users_list.push(doc.data());
        });
        return users_list
    } catch (error) {
        console.error(error)
    }
}

async function getAssociatesByIdClient(id_client) {
    try {
        let associates_list = [];
        let get_associates = await users_ref.where("client", "==", id_client).get()

        get_associates.forEach((doc) => {
            associates_list.push(doc.data());
        });
        return associates_list;
    } catch (error) {
        console.error(error)
    }
}



export default {
    getUsersByIdRole,
    getCurrentUser,
    getUsersByRank,
    getUsersById,
    getUsers,
    getUsersByIdList,
    getAssociatesByIdClient,
};